import styled, { css } from 'styled-components';
import { mq } from 'styles/mq';
import { theme } from 'styles/theme';

export const Section = styled.section`
  --toggle-spacing: 1.6rem;

  ${mq.medium} {
    --toggle-spacing: 2.4rem;
  }

  margin: 6rem 0;
`;

export const Title = styled.h1`
  margin: 0 0 2rem;
  font: 400 2.5rem ${theme.fonts.headings};
  text-transform: uppercase;

  ${mq.medium} {
    font-size: 4.5rem;
  }
`;

export const FilterToggle = styled.span<{ isSubfilter?: boolean }>`
  position: relative;
  display: inline-block;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s;

  &[data-active] {
    color: white;
  }

  &:not([data-active]) {
    cursor: pointer;

    &:hover,
    &:focus {
      opacity: 0.7;
      outline: none;
      box-shadow: none;
    }
  }

  ${(props) =>
    props.isSubfilter &&
    css`
      &[data-active]:not([data-disabled]) {
        cursor: pointer;

        &:hover,
        &:focus {
          color: #d12430;
          outline: none;
          box-shadow: none;
        }
      }
    `}
`;

export const Count = styled.span`
  display: block;
  position: absolute;
  top: 0;
  left: 100%;
  margin: 0 0.2em;
  font-size: 0.54em;
  font-weight: bold;
  color: #d12430;
`;

export const List = styled.ul<{ isPrimary?: boolean; isSubfilter?: boolean }>`
  --swiper-theme-color: white;
  --swiper-navigation-size: 3rem;

  padding: 0;

  .swiper-slide {
    width: max-content;
    padding-right: var(--toggle-spacing);
  }

  .swiper-button-prev,
  .swiper-button-next {
    height: 100%;
    top: 0;
    width: auto;
    margin-top: 0;
    pointer-events: none;

    &::after {
      pointer-events: auto;
    }
  }

  .swiper-button-prev {
    left: 0;
    padding-right: 5rem;
    background: linear-gradient(to right, black, transparent);
  }

  .swiper-button-next {
    right: 0;
    padding-left: 5rem;
    background: linear-gradient(to left, black, transparent);
  }

  .swiper-button-disabled {
    display: none;
  }

  ${(props) =>
    props.isPrimary
      ? css`
          margin: 3rem 0 2rem;

          li {
            padding-right: 2rem;
          }

          ${FilterToggle} {
            font-size: 1.4rem;
            padding: 0.4em 1em 0.3em;
            border: 1px solid currentColor;
            border-radius: 3em;
            padding: 0.5em 1em 0.4em;

            ${mq.medium} {
              font-size: 2.1rem;
            }
          }
        `
      : css`
          margin: 1rem 0;

          ${FilterToggle} {
            font-size: 1.6rem;
            line-height: 1;

            ${mq.medium} {
              font-size: 2.3rem;
            }
          }

          ${props.isSubfilter &&
          css`
            ${FilterToggle} {
              font-size: 1.3rem;

              ${mq.medium} {
                font-size: 1.8rem;
              }
            }
          `}

          .swiper-slide:not(.label-slide) + .swiper-slide {
            border-left: 1px solid #555;

            ${FilterToggle} {
              padding-left: var(--toggle-spacing);
            }
          }
        `}
`;

export const SubfilterLabel = styled.span`
  font-size: 1.3rem;
  font-weight: bold;
  line-height: 1;
  color: rgba(255, 255, 255, 0.5);

  ${mq.medium} {
    font-size: 1.8rem;
  }
`;

export const People = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 0;
  margin: 4rem 0;
  font-size: 1.6rem;
  list-style: none;

  @media (min-width: ${450 / 16}em) {
    grid-template-columns: repeat(auto-fill, minmax(10em, 1fr));
  }

  ${mq.medium} {
    font-size: 2.2rem;
  }

  li {
    display: flex;
    flex-direction: column;
    border: 1px solid #e3e3e3;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 200;
    text-align: center;
  }

  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    padding: 0.5em 1em;
    color: inherit;
    text-decoration: none;
    transition: background-color 0.3s;

    &:hover,
    &:focus {
      color: inherit;
      background-color: #282828;
    }
  }

  span {
    display: block;
  }
`;
